const wait = (wait: number) => new Promise((resolve) => setTimeout(resolve, wait))

export default wait
